import { IExerciseResultItem } from '../../../redux/api/exercises/interfaces';
import { ExerciseOptionType } from '../../../shared/constants';
import { IProgramSet } from '../../../types/interfaces/program-set';
import { ITrainingSet } from '../../../types/interfaces/training-set';

export enum SetGroupEditTableMode {
  training = 'training',
  program = 'program',
}

export const SetGroupFieldName = {
  [SetGroupEditTableMode.training]: {
    setItemsFieldName: 'trainingSetItems',
    optionsFieldName: 'trainingSetItemOptions',
    optionFieldName: 'programValue',
    optionFieldName2: 'programValue2',
  },
  [SetGroupEditTableMode.program]: {
    setItemsFieldName: 'programSetItems',
    optionsFieldName: 'programSetItemOptions',
    optionFieldName: 'value',
    optionFieldName2: 'value2',
  },
};

export interface IUseSetGroupEditTableOptions {
  hideSuperset: boolean;
  hideSetsCount: boolean;
  hideExpand: boolean;
  hideHeader: boolean;
  hideSavedSetUploading: boolean;
  hideSaveSet: boolean;
  showSetItemStatus?: boolean;
  trainingOptionValueField?: 'programValue' | 'value';
  trainingOptionValueField2?: 'programValue2' | 'value2';
  copyLastTrainingSetItemStatusOnAdd?: boolean;
  removeSetMode: 'none' | 'setGroup' | 'set' | 'both';
  hideFrame?: boolean;
}

export interface IOptionValidator {
  type?: ExerciseOptionType;
  message: string;
  validator: (option: number) => boolean;
}

export interface IUseSetGroupEditTable<
  TSet extends ITrainingSet | IProgramSet,
> {
  options: IUseSetGroupEditTableOptions;
  mode: SetGroupEditTableMode;
  maxSetNumber: number;
  submitCalled: boolean;
  optionValidators: IOptionValidator[];
  exerciseResults?: IExerciseResultItem[] | null;
  onChangeSet: (set: TSet) => void;
  // onRemoveSets?: (sets: TSet[]) => void;
  onRemoveSetsBySetNumber?: (setNumber: number, orderNumber?: number) => void;
  onAddSet?: (set: TSet) => void;
  onChangeSetOrder?: (setNumber: number, direction: 'up' | 'down') => void;
}
